module.exports = __webpack_public_path__ + "static/media/brush-2.c9e6763a.png";